import { render } from "./NameAndContinue.vue?vue&type=template&id=1982ce2c&scoped=true&ts=true"
import script from "./NameAndContinue.vue?vue&type=script&lang=ts"
export * from "./NameAndContinue.vue?vue&type=script&lang=ts"

import "./NameAndContinue.vue?vue&type=style&index=0&id=1982ce2c&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1982ce2c"]])

export default __exports__